import { render, staticRenderFns } from "./joiningNotice.vue?vue&type=template&id=c207a78e&scoped=true"
import script from "./joiningNotice.vue?vue&type=script&lang=js"
export * from "./joiningNotice.vue?vue&type=script&lang=js"
import style0 from "./joiningNotice.vue?vue&type=style&index=0&id=c207a78e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c207a78e",
  null
  
)

export default component.exports